import {EVERYONE_ELSE_GROUP_ID, type ReviewerOption} from './reviewer-options'
import type {SelectPanelItemInput} from '@primer/react'
import {GitHubAvatar} from '@github-ui/github-avatar'
import styles from './ReviewerPicker.module.css'

/**
 * Maps a plain `ReviewerOption` to SelectPanel's item shape — the only JSX in
 * the picker. "Everyone else" rows are a simple login + name; suggestions render
 * the login inline with a subtle name and surface the suggestion reason as a
 * block-variant description.
 */
export function toSelectPanelItem(option: ReviewerOption): SelectPanelItemInput {
  const {id, login, name, reason, avatarUrl, isTeam, group} = option
  const leadingVisual = () => <GitHubAvatar src={avatarUrl} size={16} square={isTeam} alt="" />

  if (group === EVERYONE_ELSE_GROUP_ID) {
    return {id, text: login, description: name ?? undefined, groupId: group, leadingVisual}
  }

  return {
    id,
    children: (
      <>
        {login}
        {name ? <span className={styles.inlineSubtleName}>{name}</span> : null}
      </>
    ),
    description: reason || undefined,
    descriptionVariant: 'block',
    groupId: group,
    leadingVisual,
  }
}
